import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SectionHeader } from 'components/common'

import { COMPONENT_EXTENDER } from 'extender'

const HomePageLayout = COMPONENT_EXTENDER('components/layouts/HomePageLayout')
const TransactionsTabs = COMPONENT_EXTENDER('components/core/Transactions/TransactionsTabs')

const TransactionsPage: FC = () => {
    const { t } = useTranslation()

    return (
        <HomePageLayout page="transfers">
            <SectionHeader>{t('Pages.transfers.Transactions')}</SectionHeader>
            <TransactionsTabs />
        </HomePageLayout>
    )
}

export default TransactionsPage
